"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { PiTicket } from "react-icons/pi";
import { LuClock5 } from "react-icons/lu";

const defaultMovies = [
  {
    id: 1,
    image: "assets/img/movie-1.jpg",
    title: "Into the Jungle",
    description: "A wild adventure in the Amazon rainforest....",
    price: "2200",
    duration: "1h 55m",
  },
  {
    id: 2,
    image: "assets/img/movie-2.jpg",
    title: "The Galactic Warriors",
    description: "A team of heroes rise to defend the universe....",
    price: "2500",
    duration: "2h 10m",
  },
  {
    id: 3,
    image: "assets/img/movie-3.jpg",
    title: "Night of Shadows",
    description: "Dark forces emerge when a portal opens....",
    price: "3000",
    duration: "2h 00m",
  },
  {
    id: 4,
    image: "assets/img/movie-4.jpg",
    title: "Jungle Returns",
    description: "An untamed expedition deep into the forest....",
    price: "2700",
    duration: "2h 05m",
  },
  {
    id: 5,
    image: "assets/img/movie-5.jpg",
    title: "Star Defenders",
    description: "A cosmic battle begins beyond the stars....",
    price: "2900",
    duration: "1h 45m",
  },
];

export default function EntertainmentSection() {
  const [movies, setMovies] = useState(defaultMovies);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const response = await fetch("/api/movies");
        if (response.ok) {
          const data = await response.json();
          if (data.movies && data.movies.length > 0) {
            setMovies(data.movies);
          }
        }
      } catch (error) {
        console.error("Failed to fetch movies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, []);

  return (
    <section className="movies-entertainment-section">
      <div className="container-fluid movies-entertainment-container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="movies-entertainment-wrapper">
              <div className="row gx-5">
                {/* Left Sticky Content */}
                <div className="col-lg-5 col-md-12">
                  <div className="movies-left-sticky">
                    <span className="movies-mini-title">
                      <span className="mini-dot"></span>
                      Cinema's
                    </span>

                    <h2 className="movies-main-title">
                      Experience the
                      <br />
                      Magic of the mini
                      <br />
                      theatre's with Plug in atmos - ready at arena cinema's
                      <br />
                    </h2>

                    <p className="movies-main-desc ">
                      Step into a world where every seat feels like the best in
                      the house. At Arena Cinemas’ mini theatres, powerful
                      Atmos-ready sound meets stunning visuals to create an
                      experience that’s intimate yet larger than life. From the
                      latest blockbusters to timeless classics, every moment
                      comes alive with clarity, depth, and emotion delivering
                      laughter, thrills, and unforgettable memories in every
                      show.
                    </p>

                    <Link href="/cinema" className="movies-cta-btn">
                      Explore Movie Bookings
                    </Link>
                  </div>
                </div>

                {/* Right Scrollable Cards */}
                <div className="col-lg-7 col-md-12">
                  <div className="movies-right-list">
                    {movies.map((item, index) => (
                      <div className="movie-item-row" key={item._id || index}>
                        <div className="movie-poster-wrap">
                          <div className="image-anime">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="movie-poster"
                            />
                          </div>
                        </div>

                        <div className="movie-content">
                          <h3 className="movie-title">{item.title}</h3>
                          <p className="movie-desc">{item.description}</p>

                          <div className="movie-divider"></div>

                          <div className="movie-meta">
                            {/* <div className="movie-meta-item">
                                                            <span className="movie-meta-icon"><PiTicket /></span>
                                                            <span>Ticket Price: {item.price}</span>
                                                        </div> */}

                            {/* <div className="movie-meta-item">
                                                            <span className="movie-meta-icon"><LuClock5 /></span>
                                                            <span>Duration: {item.duration}</span>
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
